import { usePalette } from '../hooks/usePalette';
import { useStores } from '../providers';

export function withPalette(ComponentToDecorate) {
  function DecoratedComponent(props) {
    const { playerStore } = useStores();
    const nowPlaying = playerStore.metadata();
    const palette = usePalette(nowPlaying?.image);

    return <ComponentToDecorate {...props} palette={palette} />;
  }

  return DecoratedComponent;
}
